<template>
  <el-cascader
    ref="refCascader"
    v-model="values"
    v-bind="$attrs"
    :props="props"
    :options="provinceData"
    @change="handleChange"
  ></el-cascader>
</template>

<script>
import { regionAreaTree } from "@/api/saleRule/saleF";
export default {
  data() {
    return {
      options: null,
      props: null,
      provinceData: null,
      values: [],
    };
  },
  created() {
    this.props = {
      checkStrictly: true,
    };
    this.getRegionAreaTree();
  },
  methods: {
    handleChange(val) {
      const checkedNodes = this.$refs.refCascader.getCheckedNodes(false);

      this.$emit("change", checkedNodes);
    },
    getRegionAreaTree(leve) {
      let data = {
        level: 3,
      };
      regionAreaTree(data).then((res) => {
        if (res.code === 0) {
          this.provinceData = res.data.map((provinceItem) => {
            provinceItem = this.dealChildren(provinceItem);
            return provinceItem;
          });
        }
      });
    },
    dealChildren(node) {
      node.label = node.rname;
      node.value = node.id;
      if (node.children instanceof Array && node.children.length > 0) {
        node.children.forEach((item) => {
          this.dealChildren(item);
        });
      } else {
        delete node.children;
      }

      return node;
    },
    clear() {
      this.values = [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
